import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { MdContentCopy } from 'react-icons/md';
import { copyToClipboard } from 'legacy/common/utils/clipboard';
import * as toast from 'legacy/common/utils/toast';
import { OutgoingEventProductDto } from 'api/dtos/events/products';

type PrivateTicketInfoProps = {
  ticket: OutgoingEventProductDto;
  shareUrl: string;
};

const PrivateTicketInfo: React.FC<PrivateTicketInfoProps> = ({
  ticket,
  shareUrl
}) => {
  const { t } = useTranslation(['events']);
  
  const handleCopyPrivateCode = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      copyToClipboard(ticket.shareToken);
      toast.showToast({
        type: 'success',
        message: t('events:pricingTiers.toastMessages.privateCodeCopied')
      });
    },
    [ticket.shareToken]
  );

  const handleCopyUnlockUrl = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      copyToClipboard(shareUrl);
      toast.showToast({
        type: 'success',
        message: t('events:pricingTiers.toastMessages.unlockUrlCopied')
      });
    },
    [shareUrl]
  );

  if (!ticket.isPrivate) {
return null;
}

  return (
    <div className="flex mt-4 font-semibold text-gray-500">
      <div className="mr-2 flex items-center" onClick={handleCopyPrivateCode}>
        <span>{t('events:pricingTiers.tierManagement.privateCode')}: {ticket.shareToken}</span>
        <div className="px-2">
          <MdContentCopy size={16} className="text-primary-600" />
        </div>
      </div>

      <div className="flex items-center" onClick={handleCopyUnlockUrl}>
        <span>{t('events:pricingTiers.tierManagement.unlockUrl')}</span>
        <div className="px-2">
          <MdContentCopy size={16} className="text-primary-600" />
        </div>
      </div>
    </div>
  );
};

export default PrivateTicketInfo;
